<template>
  <div>
    <Layout/>
    <h4>Pagos por Suscripción Pendientes</h4>
    <hr>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">EstadoPago</th>
          <th scope="col">SuscripcionFechaReg</th>
        </tr>
      </thead>
    <tbody>
      <tr v-for="suscpago in datosPaginados" :key="suscpago.idSuscPago">
        <td><a href="http://localhost:8080/api/v1/reportes/pdf/1/2"><i class="material-icons" style="font-size:24px;color:red; cursor: pointer;">picture_as_pdf</i></a></td>
          <td>{{suscpago.estadoPago}}</td>
          <td>{{getFormattedDate(suscpago.suscripcionFechaReg)}}</td>
        <td><button class="btn btn-light" @click="aprobarEstadoPago(suscpago)">Aprobar</button></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
import swal from  'sweetalert'
window["$"] = $;
window["jQuery"] = $;
export default {
  inject:['reload'],
  components : {
    Layout, Footer
  },
  data () {
    return {
      suscpagos : [],
      titulo:'',
      btnCrear:false,
      btnEditar:false,
      idPza:'',
      elementosPorPagina:10,
      datosPaginados:[],
      paginaActual:1
    }
  },
  mounted () {
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.suscpagos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      api.get('/vwsuscpagos/estadosuscpago/PENDIENTE').then(response=>{
      this.suscpagos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.suscpagos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    changeColor() {
        $('body').removeClass()
        $('body').addClass(this.className)
    },
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    async aprobarEstadoPago(p_SuscPago){
      p_SuscPago.estadoPago = 'APROBADA';
      try {
          await api.post('/suscpagos/actestadopago', p_SuscPago)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Orden creado(a) exitosamente!", "success");
       } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
    }
  }
}
</script>
